// Canonical external URLs used across the site.
// Referenced by content modules (and any component) so a link only changes in one place.

export const links = {
  // Opens the venue in whatever map app the visitor has.
  directions:
    "https://www.google.com/maps/search/?api=1&query=1950+Trumbull+Ave%2C+Detroit%2C+MI+48216",
  email: "mailto:detroitantiwar@gmail.com",
  instagram: "https://www.instagram.com/detroitantiwar/",
  facebook:
    "https://www.facebook.com/people/Detroit-Anti-War-Committee/61579069179416/?mibextid=wwXIfr&rdid=JqntaFXuoZQwsErT&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1Fhw429isu%2F",
  calendar:
    "https://calendar.google.com/calendar/u/0/r?cid=NWFjZTExZmJhYjhkZjQwOTIxYjg0YjMyNTJmNzI1ZDQ1NjExNTQ4YTE5ZGNlOGJjNTNhNGM2NjNjZDRlMzg1Y0Bncm91cC5jYWxlbmRhci5nb29nbGUuY29t",
  mailingList: "https://actionnetwork.org/surveys/join-dawcs-mailing-list?source=direct_link&",
  petition:
    "https://actionnetwork.org/petitions/demand-mary-sheffield-the-detroit-city-council-divest-from-genocide",
} as const;
